export default [
  {
    path: '/apps/repres-cond-pagto/list',
    name: 'apps-repres-cond-pagto-list',
    component: () => import('@/views/cadastros/apoio-vendas/repres-cond-pagto/list/Index.vue'),
    meta: {
      pageTitle: 'Representante X Condição de Pagamento',
    },
  },
  // {
  //     path: '/apps/repres-cond-pagto/edit/:id',
  //     name: 'apps-repres-cond-pagto-edit',
  //     component: () => import('@/views/cadastros/apoio-vendas/repres-cond-pagto/repres-cond-pagto-edit/RepresentanteEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Representante',
  //     },
  // },
];
